import { IUserSettingsStoreSegment } from './userSettings.interface';

export const userSettingsStoreSelector = (state: IUserSettingsStoreSegment) => state.userSettings;
